import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2","key":"svg-1"}],["path",{"d":"M13 15l1 1","key":"svg-2"}]]

const IconCircleLetterQ = createReactComponent('outline', 'circle-letter-q', 'CircleLetterQ', __iconNode);

export default IconCircleLetterQ;